import React, { useState } from 'react';
import { makeStyles,
  Typography, Tabs, Tab, Box } from '@material-ui/core';
import ManagerRegistrationsPage from './ManagerRegistrationsPage';
import ManagerSampleReceivedPage from './ManagerSampleReceivedPage';
// import ManagerResamplingPage from './ManagerResamplingPage';

const useStyles = makeStyles(() => {
  return {
    tabRoot: {
      marginLeft: '8px',
      textTransform: 'none',
      backgroundColor: '#ffffff',
      fontSize: '16px',
      color: 'rgb(100, 141, 174)',
      border: '1px solid #ccc',
      minWidth: 180,
      '&:hover': {
        color: '#ffffff',
        backgroundColor: 'rgb(100, 141, 174)',
        opacity: 1,
      },
      '&$tabSelected': {
        color: '#ffffff',
        backgroundColor: 'rgb(100, 141, 174)',
        fontWeight: 'bold',
        fontSize: '18px',
      },
    },
    tabSelected: {},
  };
});

// for tabs selection
function a11yProps(index) {
  return {
    id: `simple-tab-${ index }`,
    'aria-controls': `simple-tabpanel-${ index }`,
  };
}

// Function for Tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={ value !== index }
      id={ `simple-tabpanel-${ index }` }
      aria-labelledby={ `simple-tab-${ index }` }
      { ...other }
    >
      {value === index && (
        <Box p={ 3 }>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function ManagerRegistrationTabPage() {
  const classes = useStyles();
  const [ tab, setTab ] = useState(0);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Box pt={ 2 }>
      <Tabs
        className={ classes.customTabs }
        value={ tab }
        onChange={ handleChange }
        aria-label='registration tabs'
        indicatorColor='primary'
        textColor='rgb(100, 141, 174)'
      >
        <Tab
          label='Registration Info'
          { ...a11yProps(0) }
          classes={ { root: classes.tabRoot, selected: classes.tabSelected } }
        />
        <Tab
          label='Sample Received'
          { ...a11yProps(1) }
          classes={ { root: classes.tabRoot, selected: classes.tabSelected } }
        />
        {/* <Tab
          label='Resampling'
          { ...a11yProps(2) }
          classes={ { root: classes.tabRoot, selected: classes.tabSelected } }
        /> */}
      </Tabs>
      <TabPanel value={ tab } index={ 0 }>
        <ManagerRegistrationsPage />
      </TabPanel>
      <TabPanel value={ tab } index={ 1 }>
        <ManagerSampleReceivedPage />
      </TabPanel>
      {/* <TabPanel value={ tab } index={ 2 }>
        <ManagerResamplingPage />
      </TabPanel> */}

    </Box>
  );
}

export default ManagerRegistrationTabPage;
